/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonAddressDetailViewModel } from "../types/PersonAddressDetailViewModel.ts";
import { eAddressTypeSchema } from "./eAddressTypeSchema.ts";

export const personAddressDetailViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("Identificador único do vínculo entre a pessoa e o endereço."),
  ),
  addressId: z.optional(
    z.number().int().describe("Identificador único do endereço."),
  ),
  type: z.optional(
    z
      .lazy(() => eAddressTypeSchema)
      .describe("1 = Personal | 2 = Commercial | 3 = Payment | "),
  ),
  street: z
    .string()
    .describe("Nome do logradouro (rua, avenida, etc.). Opcional.")
    .nullish(),
  zipCode: z.string().describe("CEP do endereço. Opcional.").nullish(),
  placeNumber: z
    .string()
    .describe("Número do imóvel no logradouro. Opcional.")
    .nullish(),
  neighborhood: z.string().describe("Bairro do endereço. Opcional.").nullish(),
  complement: z
    .string()
    .describe("Complemento do endereço (apartamento, bloco, etc.). Opcional.")
    .nullish(),
  postCode: z
    .string()
    .describe("Código postal internacional do endereço. Opcional.")
    .nullish(),
  countryId: z.optional(z.number().int().describe("ID do país do endereço.")),
  stateId: z
    .number()
    .int()
    .describe("ID do estado associado ao endereço. Opcional.")
    .nullish(),
  cityId: z
    .number()
    .int()
    .describe("ID da cidade associada ao endereço. Opcional.")
    .nullish(),
  stateName: z
    .string()
    .describe("Nome do estado do endereço. Opcional.")
    .nullish(),
  cityName: z
    .string()
    .describe("Nome da cidade do endereço. Opcional.")
    .nullish(),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do registro do endereço. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do registro do endereço. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonAddressDetailViewModel>;
